// Shared by the picker and form validation so typed and native times agree.
export function parseTimeInput(value) {
    const match = String(value || "").trim().match(/^(\d{1,2})(?::(\d{2})(?::(\d{2}))?)?\s*([ap]\.?m\.?)?$/i)
    if (!match) return null
    let H = Number(match[1])
    const M = Number(match[2] || 0)
    const S = Number(match[3] || 0)
    const period = match[4]?.toLowerCase().replace(/\./g, "")
    if (M > 59 || S > 59 || (period ? H < 1 || H > 12 : H > 23)) return null
    if (period) H = H % 12 + (period === "pm" ? 12 : 0)
    return { H, M, S }
}
